var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVi = function SvgVi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M14.037 8.383a2.038 2.038 0 1 0-4.076 0H5.478c0 1.109.965 2.007 2.073 2.007h-.067c0 1.108.899 2.007 2.007 2.007 0 .981.705 1.796 1.635 1.97l-.005.012h1.756l-.005-.011a2.006 2.006 0 0 0 1.636-1.971 2.007 2.007 0 0 0 2.006-2.007h-.067c1.109 0 2.074-.898 2.074-2.007h-4.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M11.104 14.172 9.84 17.025a5.72 5.72 0 0 0 2.16.422 5.72 5.72 0 0 0 2.159-.422l-1.264-2.853h-1.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.392 9.386v3.51c0 1.997 2.608 2.609 2.608 2.609s2.609-.612 2.609-2.609v-3.51H9.392Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "m2.91 12.085 1.411 3.946 1.396-3.946h1.066l-2.036 5.217h-.852l-2.05-5.217H2.91ZM19.305 17.302v-5.217h1.014v5.217h-1.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.435 10.52v4.254a4.59 4.59 0 0 0 1.043.561V10.52h-1.043ZM13.565 10.52v4.254a4.593 4.593 0 0 1-1.043.561V10.52h1.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M14.609 9.386H9.392v1.655h5.217V9.386Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVi;